import React from 'react';
import PropTypes from 'prop-types';
import FixedHeader from '@components/FixedHeader';
import MagicHeader from '@components/MagicHeader';
import useIsDesktopLayout from '@hooks/useIsDesktopLayout';
import HeaderDescription from '../HeaderDescription';
import InnerHeader from './components/InnerHeader';

function SimpleProductConfigurationHeader({ product, onClose }) {
  const {
    description,
    priceWithDiscount,
    subsidizedProduct,
    price,
    name,
    discount,
    finalPriceWithoutTaxes,
  } = product;
  const isDesktopLayout = useIsDesktopLayout();
  return (
    <>
      {isDesktopLayout ? (
        <>
          <FixedHeader onClose={onClose} label={name} isModal />
        </>
      ) : (
        <MagicHeader
          mainHeader={
            <>
              <InnerHeader label={name} onClose={onClose} isModal />
            </>
          }
          secondHeader={<FixedHeader onClose={onClose} label={name} isModal />}
        />
      )}
      <HeaderDescription
        description={description}
        price={price}
        priceWithDiscount={priceWithDiscount}
        subsidizedProduct={subsidizedProduct}
        discount={discount}
        finalPriceWithoutTaxes={finalPriceWithoutTaxes}
      />
    </>
  );
}

SimpleProductConfigurationHeader.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    image: PropTypes.string.isRequired,
    price: PropTypes.number,
    priceWithDiscount: PropTypes.number,
    subsidizedProduct: PropTypes.object,
    itemId: PropTypes.string,
    isFavourite: PropTypes.bool,
    hasCustomPhoto: PropTypes.bool,
    discount: PropTypes.number,
    finalPriceWithoutTaxes: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
};

export default SimpleProductConfigurationHeader;
